module.exports = __webpack_public_path__ + "static/media/member_services.95a7119c.svg";